export const CHATBOT_DIMENSIONS = {
  DEFAULT: { width: 360, height: 500 },
  MIN: { width: 324, height: 240 },
  MAX: { width: 600, height: 800 },
};

export const CHATBOT_DRAGGABLE_ID = 'ai-assistant-chatbot-widget';
export const WEAVE_COPILOT_PATH = '/weave-copilot';

export const WEAVE_COPILOT_HOTKEY = {
  shortcut: 'cmd+j',
  labelMac: '⌘J',
  labelWindows: 'Ctrl+J',
};
